import { EnvironmentContextProvider } from '../../contexts/EnvironmentContext'
import useServerConfig from '../../hooks/useServerConfig'
import { SplashScreen } from '../SplashScreen'

export function ServerEnvironmentProvider(props: any) {
  const { children } = props

  const [environment, error, loading] = useServerConfig()

  return (
    <>
      <SplashScreen visible={loading} />
      <EnvironmentContextProvider environment={environment || undefined} error={error}>
        {children}
      </EnvironmentContextProvider>
    </>
  )
}
